module.exports = __webpack_public_path__ + "img/3.68f4e3ea.png";